import { z } from "zod";
import { AgencyIdSchema } from "../../primitives/ids.js";
import { ClientOpsWebsiteDeliveryStoreV1Schema } from "./store.js";
export const PORTABLE_EXPORT_POLICY_ID = "clientops.website-delivery.portable.v1";
export const ClientOpsWebsiteDeliveryPortableExportV1Schema = z
    .object({
    schemaVersion: z.literal("clientops.website-delivery-portable-export.v1.0"),
    exportPolicyId: z.literal(PORTABLE_EXPORT_POLICY_ID),
    agencyId: AgencyIdSchema,
    exportedAt: z.string().datetime(),
    store: ClientOpsWebsiteDeliveryStoreV1Schema,
    redactionNotes: z.array(z.string().min(1)),
})
    .strict();
export function exportClientOpsWebsiteDeliveryPortable(store, options) {
    if (store.agencyId.length === 0) {
        throw new Error("invalid_store_agency");
    }
    return ClientOpsWebsiteDeliveryPortableExportV1Schema.parse({
        schemaVersion: "clientops.website-delivery-portable-export.v1.0",
        exportPolicyId: PORTABLE_EXPORT_POLICY_ID,
        agencyId: store.agencyId,
        exportedAt: options?.exportedAt ?? new Date().toISOString(),
        store,
        redactionNotes: [
            "Export includes ClientOps website-delivery operational records only; BusinessGraph truth is excluded.",
            "No live provider credentials or DNS records are included.",
        ],
    });
}
//# sourceMappingURL=portable-export.js.map